module.exports = __webpack_public_path__ + "static/media/ZAPTalent-Icon-Empty.ff1c6bf8.svg";